import { Plus } from "lucide-react";
import { useState } from "react";

import { PageHeader } from "@/components/page-header";
import { QueryErrorCard } from "@/components/query-error-card";
import { TableSkeleton } from "@/components/table-skeleton";
import { Button } from "@/components/ui/button";
import { useAdminAccounts } from "@/lib/api";

import { AccountTable } from "./account-table";
import { CreateAccountDialog } from "./create-account-dialog";

export function AdminAccountsPage() {
  const accountsQuery = useAdminAccounts();
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6">
      <PageHeader
        eyebrow="Customer onboarding"
        title="Customer accounts"
        description="Onboard customers, manage their contacts, and grant MCP access so they can connect their own AI clients to the platform's data endpoint."
        actions={
          <Button onClick={() => setCreateOpen(true)}>
            <Plus className="h-4 w-4" />
            New account
          </Button>
        }
      />

      {accountsQuery.isLoading ? (
        <TableSkeleton columns={4} />
      ) : accountsQuery.isError ? (
        <QueryErrorCard
          message="Could not load accounts."
          onRetry={() => void accountsQuery.refetch()}
          backTo="/home"
        />
      ) : (
        <AccountTable accounts={accountsQuery.data ?? []} />
      )}

      <CreateAccountDialog open={createOpen} onOpenChange={setCreateOpen} />
    </div>
  );
}
